
import ActionButtons from './ActionButtons';
import { actionButtonsComiteeName } from './ActionButtons/actionButtonsArray';

/**
 * @description bu komponent madde sorumlusundan duzenleme talep edildigikten sonra madde sorumlusunun maddeyi gondermesi icin gereken alana ulasmasini saglayan alan
 * @param {number} step - step number
 * @param {string} committee - committee (owner_committee)
 * @param {number} offerId - offer id
 * @returns {React.ReactNode}
 */
function SupervisorControlDecision({ committee, step, offerId }) {
  return (
    <ActionButtons
      buttonType={actionButtonsComiteeName.supervisorControlDecision}
      committee={committee}
      step={step}
      offerId={offerId}
    />
  );
}

export default SupervisorControlDecision;
